import React, { Component } from 'react';
import { Form, Input, List, Spin } from 'antd';
import { Header } from 'components';
import {
  Container,
  Colors,
  FormWrapper,
  PrimaryButton,
  Section,
  isMobile,
  Modal,
  H2,
} from 'utils';
import { Table } from 'antd';
import styled from '@emotion/styled';
import { store } from 'react-notifications-component';
import { adminServices } from 'services';
import { connect } from 'react-redux';
import { AdminActions } from 'redux/actions';
import PropTypes from 'prop-types';
import { CitiesSelect, CategoriesSelect } from 'components';
import ContactModal from 'scenes/Project/components/ContactModal';
const TableWrapper = styled.div`
  padding: 50px 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  min-width: 0;
`;
const notification = {
  insert: 'top',
  container: 'top-right',
  animationIn: ['animate__animated animate__fadeIn'], // `animate.css v4` classes
  animationOut: ['animate__animated animate__fadeOut'], // `animate.css v4` classes
  dismiss: {
    duration: 5000,
    onScreen: true,
  },
};

const Wrapper = styled.div`
  .container {
    max-width: 1000px;
    color: ${Colors.GreenColor};
    h1 {
      color: ${Colors.GreenColor};
      display: inline-block;
      padding: 10px;
      border-radius: 10px;
      font-size: 35px;
      margin-top: 30px;
      margin-bottom: 0px;
      font-weight: bold;
      width: 100%;
      text-align: center;
    }
  }
  label {
    font-weight: bold;
    font-size: 22px;
    display: block;
  }

  .submit-button {
    text-align: center;
    margin-top: 50px;
  }
  .ant-form-item {
    display: block;
    .ant-form-item-label {
      color: ${Colors.GreenColor};
      margin-bottom: 10px;
    }
    .ant-picker,
    .ant-input-affix-wrapper {
      width: 100%;
      padding: 10px;
      border: 1px solid ${Colors.GreenColor};
      border-radius: 10px;
    }
  }
  .ant-select-selector,
  input,
  textarea {
    border-radius: 15px !important;
    width: 100%;
    border-radius: 10px;
    line-height: 22px;
    vertical-align: middle;
  }
  .subtitle {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
  }
  .intro-text {
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 30px;
  }
`;

class AdminRecurringPayments extends Component {
  static propTypes = {
    goodies: PropTypes.any,
    getAdminRecurringPayments: PropTypes.func.isRequired,
  };

  state = {
    dataArray: [],
    showModal: false,
    selectedDonationId: '',
    runningDonationId: null,
  };
  componentDidMount() {
    const { getAdminRecurringPayments } = this.props;
    getAdminRecurringPayments();
  }

  handelCloseModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflowY = 'unset';
  };
  handelShowModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflowY = 'hidden';
  };

  handelCloseLoginModal = () => {
    this.setState({ showLoginModal: false });
    document.body.style.overflowY = 'unset';
  };

  handleSelectedDonation = (id) => {
    this.setState({ selectedDonationId: id });
  };
  handleRequestCancelRecurringPayment = () => {
    const { adminCancelRecurringPayment, getAdminRecurringPayments } =
      this.props;
    if (this.state.selectedDonationId) {
      adminCancelRecurringPayment(this.state.selectedDonationId);
      getAdminRecurringPayments();
    }
  };

  handleRunRecurringPaymentNow = (donationId, sidekiqJobId) => {
    const confirmed = window.confirm(
      `Donation ${donationId} jetzt ausführen? Dadurch kann der Spender sofort belastet werden.`
    );
    if (!confirmed) return;

    this.setState({ runningDonationId: donationId });

    adminServices
      .runRecurringPaymentNow(donationId, sidekiqJobId)
      .then((result) => {
        store.addNotification({
          ...notification,
          title: 'Job gestartet',
          type: 'success',
          message: `Donation ${result.donation_id} wird jetzt ausgeführt. Job ID: ${result.sidekiq_job_id}`,
        });
        this.setState({ runningDonationId: null });
      })
      .catch((error) => {
        const errors = error.errors;
        const message = Array.isArray(errors)
          ? errors.join(', ')
          : errors?.full_messages?.join(', ') ||
            errors ||
            'Der wiederkehrende Job konnte nicht gestartet werden.';

        store.addNotification({
          ...notification,
          title: 'Fehler!',
          type: 'danger',
          message,
        });
        this.setState({ runningDonationId: null });
      });
  };

  render() {
    const { showModal, runningDonationId } = this.state;
    const { loading, recurringDonations } = this.props;
    const columns = [
      {
        title: 'Project ID',
        dataIndex: 'project_id',
        key: 'project_id',
        width: '200px',
      },
      {
        title: 'Donation ID',
        dataIndex: 'donation_id',
        key: 'donation_id',
        width: '140px',
      },
      {
        title: 'Stripe PaymentIntent ID',
        dataIndex: 'stripe_id',
        key: 'stripe_id',
        width: '280px',
        render: (stripeId) => stripeId || '—',
      },
      {
        title: 'Sidekiq Job ID',
        dataIndex: 'sidekiq_job_id',
        key: 'sidekiq_job_id',
        width: '260px',
        render: (jobId) => jobId || '—',
      },
      {
        title: 'Vorname',
        dataIndex: 'first_name',
        key: 'firstName',
      },
      {
        title: 'Nachname',
        dataIndex: 'last_name',
        key: 'lastname',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Projekttitel',
        dataIndex: 'title',
        key: 'title',
      },
      {
        title: 'Spendenart',
        dataIndex: 'donation_type',
        key: 'donationtype',
        width: '100px',
      },
      {
        title: 'Spendenbetrag',
        dataIndex: 'amount',
        key: 'amount',
        width: '100px',
      },
      {
        title: 'Tips',
        dataIndex: 'tips',
        key: 'tips',
        width: '100px',
      },
      {
        title: 'Created Time',
        dataIndex: 'time',
        key: 'time',
        width: '250px',
      },
      {
        title: 'Canceled At',
        dataIndex: 'canceled_at',
        key: 'canceled_at',
        width: '250px',
      },
      {
        title: 'UTM Source',
        dataIndex: 'utm_source',
        key: 'utm_source',
        width: '300px',
      },
      {
        title: 'UTM Medium',
        dataIndex: 'utm_medium',
        key: 'utm_medium',
        width: '300px',
      },
      {
        title: 'UTM Campaign',
        dataIndex: 'utm_campaign',
        key: 'utm_campaign',
        width: '300px',
      },
      {
        title: 'UTM Term',
        dataIndex: 'utm_term',
        key: 'utm_term',
        width: '300px',
      },
      {
        title: 'UTM Content',
        dataIndex: 'utm_content',
        key: 'utm_content',
        width: '300px',
      },
      {
        title: 'UTM Adgroup',
        dataIndex: 'utm_adgroup',
        key: 'utm_adgroup',
        width: '300px',
      },
      {
        title: 'UTM Placement',
        dataIndex: 'utm_placement',
        key: 'utm_placement',
        width: '300px',
      },
      {
        title: 'UTM Device',
        dataIndex: 'utm_device',
        key: 'utm_device',
        width: '300px',
      },
      {
        title: 'UTM Audience',
        dataIndex: 'utm_audience',
        key: 'utm_audience',
        width: '300px',
      },
      {
        title: 'UTM Geo',
        dataIndex: 'utm_geo',
        key: 'utm_geo',
        width: '300px',
      },
      {
        title: 'UTM Creative',
        dataIndex: 'utm_creative',
        key: 'utm_creative',
        width: '300px',
      },
      {
        title: 'UTM Network',
        dataIndex: 'utm_network',
        key: 'utm_network',
        width: '300px',
      },
      {
        title: 'UTM ID',
        dataIndex: 'utm_id',
        key: 'utm_id',
        width: '300px',
      },
      {
        title: 'Aktion',
        dataIndex: 'id',
        key: 'action',
        width: '320px',
        render: (id, data) => (
          <div style={{ display: 'flex', gap: '10px' }}>
            <PrimaryButton
              minWidth={isMobile() ? '20%' : '100px'}
              onClick={() =>
                this.handleRunRecurringPaymentNow(
                  data.donation_id,
                  data.sidekiq_job_id
                )
              }
              primary={true}
              disabled={
                data.status === 'canceled' ||
                runningDonationId === data.donation_id
              }
              style={{
                opacity:
                  data.status === 'canceled' ||
                  runningDonationId === data.donation_id
                    ? 0.6
                    : 1,
                cursor:
                  data.status === 'canceled' ||
                  runningDonationId === data.donation_id
                    ? 'not-allowed'
                    : 'pointer',
              }}
            >
              {runningDonationId === data.donation_id
                ? 'Wird gestartet...'
                : 'Jetzt ausführen'}
            </PrimaryButton>
            <PrimaryButton
              minWidth={isMobile() ? '20%' : '100px'}
              onClick={
                data.status === 'canceled'
                  ? undefined
                  : () => {
                      this.handleSelectedDonation(id);
                      this.handelShowModal();
                    }
              }
              primary={true}
              disabled={data.status === 'canceled'}
              style={{
                opacity: data.status === 'canceled' ? 0.6 : 1,
                cursor: data.status === 'canceled' ? 'not-allowed' : 'pointer',
              }}
            >
              {data.status === 'canceled' ? 'Canceled' : 'stornieren'}
            </PrimaryButton>
          </div>
        ),
      },
    ];

    return (
      <>
        <ContactModal />
        <Wrapper>
          <Header relativeHeader={true} />
          <Container className="">
            <Section>
              <h1>Admin Ihre wiederkehrenden Projekte</h1>
              <TableWrapper>
                <Table
                  columns={columns}
                  dataSource={recurringDonations?.donations}
                  rowKey="donation_id"
                  pagination={false}
                  loading={loading}
                  scroll={{ x: 6000 }}
                />
              </TableWrapper>
            </Section>
          </Container>
        </Wrapper>
        <Modal showModal={showModal} handelCloseModal={this.handelCloseModal}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '20px',
              alignItems: 'center',
            }}
          >
            <H2>bist du sicher ?</H2>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '20px',
              alignItems: 'center',
            }}
          >
            <PrimaryButton
              minWidth={isMobile() ? '20%' : '100px'}
              onClick={() => {
                this.handelCloseModal();
                this.handleRequestCancelRecurringPayment();
              }}
              primary={true}
            >
              Ja
            </PrimaryButton>
            <PrimaryButton
              minWidth={isMobile() ? '20%' : '100px'}
              onClick={() => {
                this.handelCloseModal();
              }}
              primary={true}
            >
              Nein
            </PrimaryButton>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { recurringDonations, loading } = state.admin;
  return {
    recurringDonations,
    loading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAdminRecurringPayments: () =>
    dispatch(AdminActions.getAdminRecurringPayments()),
  adminCancelRecurringPayment: (id) =>
    dispatch(AdminActions.AdmincancelRecurringPayment(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminRecurringPayments);
